import { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/esm/Card";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrieveAccordion } from "../../redux/slice/accordion-slice";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Convergence2023Banner from "./components/convergence-2023-banner";

const Convergence2023AttendeeProfile = () => {
  const path = "Convergence-2023%2FAttendee-Profile";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);
  const { AccordionData } = useSelector((state: RootState) => state.Accordion);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
    dispatch(retrieveAccordion(`%2F${path}%2FAccordion-Items`));
  }, [dispatch]);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "convergence-2023-attendee-profile-script" });
  // End Dynamic Scripts

  return (
    <>
      <Convergence2023AttendeeProfileStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Convergence2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <p>&nbsp;</p>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>

            <Accordion flush className="convergence" id="info">
              {AccordionData[0]?.data?.map((item, index) => {
                return (
                  <Card>
                    <Card.Header>
                      <Accordion.Item eventKey={index.toString()} key={index}>
                        <Accordion.Header className="btn btn-block heading">
                          <span dangerouslySetInnerHTML={{ __html: item.name }}></span>
                          <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow">
                            &nbsp;
                          </i>
                        </Accordion.Header>
                        <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                      </Accordion.Item>
                    </Card.Header>
                  </Card>
                );
              })}
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

export default Convergence2023AttendeeProfile;

const Convergence2023AttendeeProfileStyleComponent = () => {
  return (
    <>
      <style>
        {`
          table.stats td { color: #0A2A65; font-size: 26px; font-weight: bold; }
          table.stats td:nth-child(1) { border-right: 2px solid #3C89C6; }
          table.stats td:nth-child(2) { color: #94264F;  text-align: center; }
          table.stats tbody tr:nth-child(2n+1) {  background: #CFE7F8; }
          .accordion .btn { text-transform: none !important;  }
          .heading { color: #19204A; font-weight: normal; }

          .mainstats img { height: 150px; margin-top: 25px; margin-bottom: 10px; }
          .mainstats .text { color: #FAAC2E; font-size: 20px; }
          .mainstats .num { color: #94264F; font-size: 18px; font-weight: bold; }

          @media  only screen and (max-width: 768px) {  
            .attendstat { font-size: x-large !important; }
            .align-mobile { text-align: left !important; }
          }
          #info .card{
            margin: 0;
          }
          table{
            table-layout: fixed;
          }
          table.stats td{
            border: none;
          }
          @media(max-width: 767px){
            table.stats td{
              font-size: 18px;
            }
            .card-header {
              padding: 0;
          }
          table.stats td:nth-child(2) { 
            width: 100px;
           }
          }
        `}
      </style>
    </>
  );
};
